import { render } from "./ListNomenclatureTypesActionButtonsRenderer.vue?vue&type=template&id=5d45eba3"
import script from "./ListNomenclatureTypesActionButtonsRenderer.vue?vue&type=script&lang=js"
export * from "./ListNomenclatureTypesActionButtonsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__